const useLogoUrlReplacement = () => {
  const badResolutionLogos = ['wa.gov'];
  const isBadResolutionLogo = (urlString) => {
    return badResolutionLogos.some((badLogo) => urlString?.toLowerCase().includes(badLogo.toLowerCase()));
  };
  const replacementOfUrl = ({ url }) => {
    if (url) {
      const urlObject = new URL(url);
      const searchParams = new URLSearchParams(urlObject?.search);
      searchParams.set('token', import.meta.env.VITE_APP_LOGO_DOT_DEV_TOKEN);
      searchParams.set('fallback', '404');
      searchParams.delete('size');
      if (url?.toLowerCase()?.startsWith('https://img.logo.dev') && !isBadResolutionLogo(url)) {
        return `${urlObject?.origin}/${normalizeUrl(urlObject?.pathname)}?${searchParams?.toString()}`;
      } else {
        return url;
      }
    }
  };
  const clientLogoReplacement = ({ organisationLogo }) => {
    if (organisationLogo) {
      if (organisationLogo?.startsWith('https://img.logo.dev')) {
        return replacementOfUrl({ url: organisationLogo });
      } else {
        return `${import.meta.env.VITE_APP_DOTNETAPIURL}/api/cors/resource?url=${encodeURIComponent(
          organisationLogo
        )}&mime=${encodeURIComponent('image/png')}&cache=true`;
      }
    } else {
      return `${import.meta.env.VITE_APP_DOTNETAPIURL}/api/cors/resource?url=${encodeURIComponent(
        `${import.meta.env.VITE_APP_CDNURL}/images/20230909-company-placeholder.png`
      )}&mime=${encodeURIComponent('image/png')}&cache=true`;
    }
  };

  const normalizeUrl = (url) => {
    url = url.trim();
    url = url.replace(/^\//, '');
    url = url.replace(/^https?:\/\//i, '');
    url = url.replace(/\/$/, '');
    return url;
  };

  const initialSourceCode = () => {
    switch (import.meta.env.VITE_APP_APPURL) {
      case 'https://us.policymogul.com':
        return 'us-';
      case 'https://policymogul.com':
        return '';
      case 'https://us-staging.policymogul.com':
        return 'us-staging-';
      case 'https://staging.policymogul.com':
        return 'staging-';
      default:
        return 'dev-';
    }
  };

  const createImageStateUrl = (imageState) => {
    if (imageState) {
      if (imageState.src.startsWith('data:')) {
        return imageState.src;
      } else {
        const imageStateUrl = new URL(imageState.src);
        const searchParams = new URLSearchParams(imageStateUrl?.search);
        searchParams?.set('v', '1');
        searchParams?.set('source', `${initialSourceCode()}pm`);
        return `${imageStateUrl?.origin}${imageStateUrl?.pathname}?${searchParams?.toString()}`;
      }
    }
  };

  return { replacementOfUrl, clientLogoReplacement, normalizeUrl, createImageStateUrl, isBadResolutionLogo };
};

export default useLogoUrlReplacement;
